var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.703 0.748047C13.0953 0.748047 16.656 6.69416 16.656 14.029C16.656 21.3639 13.0953 27.31 8.703 27.31C4.31069 27.31 0.75 21.3639 0.75 14.029C0.75 6.69416 4.31069 0.748047 8.703 0.748047Z",
    fill: "#F5F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.703 -0.00195312C13.583 -0.00195312 17.406 6.16105 17.406 14.0291C17.406 21.8971 13.583 28.0601 8.703 28.0601C3.823 28.0601 0 21.8971 0 14.0291C0 6.16105 3.823 -0.00195312 8.703 -0.00195312ZM8.703 26.5601C12.675 26.5601 15.906 20.9391 15.906 14.0291C15.906 7.11906 12.675 1.49805 8.703 1.49805C4.73099 1.49805 1.5 7.11906 1.5 14.0291C1.5 20.9391 4.73099 26.5601 8.703 26.5601Z",
    fill: "#8E3B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46903 9.06934C9.20836 9.06934 11.429 11.29 11.429 14.0293C11.429 16.7687 9.20836 18.9893 6.46903 18.9893C3.7297 18.9893 1.50903 16.7687 1.50903 14.0293C1.50903 11.29 3.7297 9.06934 6.46903 9.06934Z",
    fill: "#8E3B00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46905 10.4648C8.43795 10.4648 10.0341 12.061 10.0341 14.0298C10.0341 15.9987 8.43795 17.5948 6.46905 17.5948C4.50016 17.5948 2.90405 15.9987 2.90405 14.0298C2.90405 12.061 4.50016 10.4648 6.46905 10.4648Z",
    fill: "#292F33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78599 10.0459C8.57354 10.0459 9.21199 10.6843 9.21199 11.4719C9.21199 12.2595 8.57354 12.8979 7.78599 12.8979C6.99843 12.8979 6.35999 12.2595 6.35999 11.4719C6.35999 10.6843 6.99843 10.0459 7.78599 10.0459Z",
    fill: "#F5F8FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.109 0.748047C31.5013 0.748047 35.062 6.69416 35.062 14.029C35.062 21.3639 31.5013 27.31 27.109 27.31C22.7167 27.31 19.156 21.3639 19.156 14.029C19.156 6.69416 22.7167 0.748047 27.109 0.748047Z",
    fill: "#F5F8FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.109 -0.00195312C31.989 -0.00195312 35.813 6.16105 35.813 14.0291C35.813 21.8971 31.989 28.0601 27.109 28.0601C22.229 28.0601 18.406 21.8971 18.406 14.0291C18.406 6.16105 22.229 -0.00195312 27.109 -0.00195312ZM27.109 26.5601C31.081 26.5601 34.313 20.9391 34.313 14.0291C34.313 7.11906 31.081 1.49805 27.109 1.49805C23.137 1.49805 19.906 7.12006 19.906 14.0291C19.906 20.9391 23.137 26.5601 27.109 26.5601Z",
    fill: "#8E3B00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.875 9.06934C27.6144 9.06934 29.835 11.29 29.835 14.0293C29.835 16.7687 27.6144 18.9893 24.875 18.9893C22.1357 18.9893 19.915 16.7687 19.915 14.0293C19.915 11.29 22.1357 9.06934 24.875 9.06934Z",
    fill: "#8E3B00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8751 10.4648C26.844 10.4648 28.4401 12.061 28.4401 14.0298C28.4401 15.9987 26.844 17.5948 24.8751 17.5948C22.9062 17.5948 21.3101 15.9987 21.3101 14.0298C21.3101 12.061 22.9062 10.4648 24.8751 10.4648Z",
    fill: "#292F33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.192 10.0459C26.9795 10.0459 27.618 10.6843 27.618 11.4719C27.618 12.2595 26.9795 12.8979 26.192 12.8979C25.4044 12.8979 24.766 12.2595 24.766 11.4719C24.766 10.6843 25.4044 10.0459 26.192 10.0459Z",
    fill: "#F5F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.f5543074af3563bafdd0f0191851a2cc.svg";
export { ForwardRef as ReactComponent };